import { GridInformation } from 'vnetwork-ui'
import { getTicketAttachments } from '@/modules/Ticket/services'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import FileItem from '@/components/Form/Shared/FileItem'
import { IPermissionProps } from '@/types/shared'
import { useFilePreview } from '@/contexts/file-preview'
import { Attachment } from 'vnetwork-ui/dist/components/FilePreviewDialog'
import toast from 'react-hot-toast'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const TicketAttachments: React.FC<IPermissionProps> = () => {
    const { ticketID } = useParams<{ ticketID: string }>()
    const { t } = useTranslation()
    const { preview } = useFilePreview()

    const handlePreview = async (attachment: Attachment) => {
        const path = attachment?.attachment_file_url
        if (!path) {
            toast.error('Không có file path')
            return
        }

        try {
            const formatPath = path.split('/').pop()
            const url = import.meta.env.APP_STORAGE
            const formatUrl = `${url}/${path}`

            preview(formatUrl, undefined, {
                attachment_file_name: formatPath,
                attachment_file_url: formatUrl,
            })
        } catch {
            toast.error('something went wrong')
        }
    }

    const { data: ticketAttachment, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.TICKET_ATTACHMENT, ticketID],
        queryFn: async () => {
            const result = await getTicketAttachments({
                ticket_id: Number(ticketID) || 0,
            })
            return result
        },
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <GridInformation
            data={
                ticketAttachment?.results
                    ?.map((item) => [
                        {
                            label: '',
                            value: item?.ticket_attachment_path ? (
                                <div
                                    className="cursor-pointer hover:opacity-70"
                                    onClick={() =>
                                        handlePreview({
                                            attachment_file_url:
                                                item.ticket_attachment_path,
                                            attachment_file_name:
                                                item.ticket_attactment_name,
                                        } as Attachment)
                                    }
                                >
                                    <FileItem
                                        name={item?.ticket_attactment_name}
                                        preview={`${import.meta.env.APP_STORAGE}/${item?.ticket_attachment_path}`}
                                        size={item?.ticket_attachment_size}
                                    />
                                </div>
                            ) : null,
                            hidden: !item?.ticket_attachment_path,
                            className: 'md:col-span-4 col-span-1',
                        },
                    ])
                    ?.flat() || [
                    {
                        label: '',
                        value: t('ticket-attachment-list'),
                        className: 'col-span-full text-left text-gray-500',
                    },
                ]
            }
            className="mt-4"
        />
    )
}

export default TicketAttachments
